import { UiVaultConfig } from 'src/@types/vaults';
import { VaultManagerIcon } from './VaultManagerIcon';
import { useVaultStats } from 'src/hooks/query/vaults/derived/useVaultStats';
import { VaultTags } from './VaultTags';

export const VaultSidebarInfoHeader = (props: {
	uiVaultConfig: UiVaultConfig;
}) => {
	const { data: vaultStats } = useVaultStats(
		props.uiVaultConfig.vaultPubkeyString
	);
	const numOfVaultSnapshots = vaultStats?.numOfVaultSnapshots ?? 0;

	return (
		<>
			<VaultManagerIcon uiVaultConfig={props.uiVaultConfig} size={40} />
			<div className="flex flex-col gap-y-xs">
				{props.uiVaultConfig.name}
				<VaultTags
					uiVaultConfig={props.uiVaultConfig}
					numOfVaultSnapshots={numOfVaultSnapshots}
				/>
			</div>
		</>
	);
};
